export default __webpack_public_path__ + "static/media/hht1_ep18_timeline_10.6bd56832.png";